export default __webpack_public_path__ + "static/media/WM0400.34I-43895_-26195_0.1be7f419.jpg";